// @ts-nocheck
import { createContext } from 'react';

const FormResultsContext = createContext([{ state: {}, actions: {} }]);
export default FormResultsContext;
